import service from "@/service/service";

// 首页统计
export const statIndex = () =>
    service.get("/stat/index");

